import { apiSlice } from "../../app/api/apiSlice";

export const surveysApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSurveys: builder.query({
      query: () => "/survey",
      // keepUnusedDataFor: 5,
      providesTags: (result) =>
        result
          ? [...result.map(({ _id }) => ({ type: "Survey", id: _id })), "Survey"]
          : ["Survey"],
    }),
    getSurveyById: builder.query({
      query: (id) => `/survey/${id}`,
      providesTags: (result) => [
        { type: "Survey", id: result?.survey?._id },
      ],
    }),
    getMemberVisibleSurveys: builder.query({
      query: () => "/survey/member-visible",
      providesTags: (result) =>
        result
          ? [...result.map(({ _id }) => ({ type: "Survey", id: _id })), "Survey"]
          : ["Survey"],
    }),
    addNewSurvey: builder.mutation({
      query: (survey) => ({
        url: "/survey",
        method: "POST",
        body: {
          ...survey,
        },
        invalidatesTags: ["Survey"],
      }),
    }),
    updateSurvey: builder.mutation({
      query: (data) => ({
        url: "/survey",
        method: "PATCH",
        body: { ...data },
        invalidatesTags: ["Survey"],
      }),
    }),
    deleteSurvey: builder.mutation({
      query: (data) => ({
        url: "/survey",
        method: "DELETE",
        body: data,
        invalidatesTags: ["Survey"],
      }),
    }),
  }),
});

export const {
  useGetSurveysQuery,
  useGetSurveyByIdQuery,
  useGetMemberVisibleSurveysQuery,
  useAddNewSurveyMutation,
  useUpdateSurveyMutation,
  useDeleteSurveyMutation,
} = surveysApiSlice;
